export default __webpack_public_path__ + "static/media/Alliance-maladies-rares.feeced06.png";